<ng-container *ngIf="subMetrics && subMetrics.length > 0; else defaultKpiCard">
  <!-- Multi-metric Header Card (Matching New Figma/Mockup Design) -->
  <div class="lib-card-container" [class]="theme ? 'theme-' + theme : ''" [style.--kc]="accentColor">
    <div class="lib-card-header">
      <div
        class="lib-kpi-icon-wrap"
        [style.backgroundColor]="iconBgColor"
        [style.borderColor]="iconBorderColor"
      >
        <ng-container *ngIf="svgPath">
          <svg
            class="lib-kpi-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.2"
            stroke-linecap="round"
            stroke-linejoin="round"
            [style.color]="iconColor"
          >
            <path [attr.d]="svgPath"></path>
          </svg>
        </ng-container>
        <ng-container *ngIf="icon && !svgPath">
          <mat-icon class="lib-kpi-mat-icon" [style.color]="iconColor">{{ icon }}</mat-icon>
        </ng-container>
      </div>

      <div class="lib-header-text">
        <h3 class="lib-kpi-label">{{ title || label }}</h3>
      </div>
    </div>

    <div class="lib-card-body">
      <ng-container *ngFor="let item of subMetrics; let last = last">
        <div class="lib-kpi-subcol">
          <span class="lib-kpi-sublabel">{{ item.label }}</span>
          <span class="lib-kpi-subval" [style.color]="item.valueColor || valueColor">{{ item.value }}</span>
        </div>
        <div *ngIf="!last" class="lib-kpi-divider"></div>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #defaultKpiCard>
  <div class="lib-kpi-card" [style.--kc]="accentColor">
    <div
      class="lib-kpi-icon-wrap"
      [style.backgroundColor]="iconBgColor"
      [style.borderColor]="iconBorderColor"
    >
      <ng-container *ngIf="svgPath">
        <svg
          class="lib-kpi-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          [style.color]="iconColor"
        >
          <path [attr.d]="svgPath"></path>
        </svg>
      </ng-container>

      <ng-container *ngIf="icon && !svgPath">
        <mat-icon
          class="lib-kpi-mat-icon"
          [style.color]="iconColor"
        >{{ icon }}</mat-icon>
      </ng-container>
    </div>

    <div class="lib-kpi-label">{{ label }}</div>

    <div class="lib-kpi-value" [style.color]="valueColor">
      <ng-container *ngIf="!loading; else loadingTpl">
        {{ value }}
      </ng-container>
      <ng-template #loadingTpl>
        <span class="lib-kpi-skeleton"></span>
      </ng-template>
    </div>
  </div>
</ng-template>
